import { checkVersionRequest, setResubscribeToChannel, subscribeToChannel } from './AppActions';

// App
export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    socket.on('app/update/web', () => {
        dispatch(checkVersionRequest());
    });

    socket.on('disconnect', () => {
        console.log('WS::: Disconnected');
        // typeof window !== 'undefined' && window.location.reload();
        setTimeout(() => {
            dispatch(setResubscribeToChannel());
        }, 3000);
    });

    if(process.env.NODE_ENV === 'development') {
        dispatch(subscribeToChannel('test'));
        socket.on('app/tested', data => {
            console.log('APP::: WS successfully tested', data);
        });
    }
}
